import { Injectable } from '@angular/core';
import { HttpClient, HttpRequest, HttpHandler, HttpEvent, HttpInterceptor, HttpErrorResponse } from '@angular/common/http';

import { AuthService } from '../services/auth.service';
import { Observable, throwError, BehaviorSubject } from 'rxjs';
import { catchError, filter, take, switchMap, tap, ignoreElements } from 'rxjs/operators';
import { environment } from './../../environments/environment';
import * as uuid from 'uuid';

@Injectable()
export class TokenInterceptor implements HttpInterceptor {

  private isRefreshing = false;
  private refreshTokenSubject: BehaviorSubject<any> = new BehaviorSubject<any>(null);
  private formDataURL = [environment.URL_ADD_EVENT, environment.URL_EDIT_EVENT, environment.URL_CREATE_USER, environment.URL_UPDATE_USER, environment.URL_CREATE_NEW_PLOT, , environment.URL_UPDATE_NEW_PLOT]

  constructor(public authService: AuthService, private http: HttpClient) { }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

    if (this.authService.getJwtToken()) {
      request = this.addToken(request, this.authService.getJwtToken());
    }
    return next.handle(request).pipe(catchError(error => {
      if (error instanceof HttpErrorResponse && error.status === 401) {
        return this.handle401Error(request, next);
      } else {
        return throwError(error);
      }
    }));
  }

  private addToken(request: HttpRequest<any>, token: string) {
    // console.log("formDataURL :", this.formDataURL)
    let isFormData = false
    let isThaiCom = false
    this.formDataURL.forEach(element => {
      if (request.url.indexOf(element) !== -1) {
        isFormData = true
      }
      if(request.url.includes("earthinsights")){
        isThaiCom = true
      }
    });
    if (isFormData) {
      // console.log("isFormData: ",isFormData)
      return request.clone({
        setHeaders: {
          //'Content-Type': 'application/json', 
          'Authorization': `Bearer ${token}`,
          'auth': this.authService.getAuthInfo(),
          'x-req-transactionid': uuid.v4(),
        }
      });
      
    } 
    else if(isThaiCom){
      return request.clone({});
    } else {
      return request.clone({
        setHeaders: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`,
          'auth': this.authService.getAuthInfo(),
          'x-req-transactionid': uuid.v4(),
        }
      });
    }
  }

  private handle401Error(request: HttpRequest<any>, next: HttpHandler) {
    if (!this.isRefreshing) {
      this.isRefreshing = true;
      this.refreshTokenSubject.next(null);

      return this.authService.refreshToken().pipe(
        switchMap((token: any) => {
          // console.log("token @@ ", token);
          
          if (token.code == 400) {
            // console.log("TOKEN INVALID")
            //invalid token => logout
            //return
          }
          if(token.data){
            this.isRefreshing = false;
            this.refreshTokenSubject.next(token.data.access_token);
            return next.handle(this.addToken(request, token.data.access_token));
          }else{
            this.isRefreshing = false;
            this.refreshTokenSubject.next("");
            return next.handle(this.addToken(request, ""));
          }
        }));
    } else {
      return this.refreshTokenSubject.pipe(
        filter(token => token != null),
        take(1),
        switchMap(jwt => {
          return next.handle(this.addToken(request, jwt));
        }));
    }
  }
}